<div class="flex-row flex">
    <div class="flex">
        <mat-tab-group [selectedIndex]="currentTabIndex"
                       mat-stretch-tabs="false"
                       (selectedIndexChange)="tabIndexChanged($event)">
            <mat-tab label="Build Programme Template">
                <ng-template [matTabContent]>
                    @if (template) {
<div
                         class="cb-padding flex-row flex">
                        <div class="scrollable-container cb-padding-right flex">
                            <div style="text-align: right;">
                                <button mat-raised-button
                                        class="cb-margin-bottom"
                                        (click)="expandOrCollapseAll()">
                                    @if (!isAllExpanded()) {
<span>Expand All&nbsp;</span>
}
                                    @if (isAllExpanded()) {
<span>Collapse All&nbsp;</span>
}
                                    @if (!isAllExpanded()) {
<mat-icon>keyboard_arrow_down</mat-icon>
}
                                    @if (isAllExpanded()) {
<mat-icon>keyboard_arrow_up</mat-icon>
}
                                </button>
                            </div>

                            <div cdkDropList
                                 id="template-stages-drop-list"
                                 [cdkDropListData]="template.stages"
                                 [cdkDropListConnectedTo]="[DropList.AvailableStages]"
                                 (cdkDropListDropped)="dropStage($event)"
                                 [cdkDropListDisabled]="!isEditing$.value">
                                @for (stage of template.stages; track stage) {
<mat-expansion-panel cdkDrag
                                                     class="panel cb-margin-bottom"
                                                    
                                                     [(expanded)]="expansionPanelStates[stage.buildStageId]">
                                    <mat-expansion-panel-header>
                                        <mat-panel-title>
                                            <strong>{{ stage.buildStageCode }}</strong>
                                            <span class="cb-margin-left-2x">{{ stage.buildStageLabel }}
                                                ({{ stage.activities?.length || 0 }})</span>
                                        </mat-panel-title>
                                        @if (isEditing$.value) {
<button
                                                class="cb-margin-right-3x"
                                                mat-icon-button
                                                (click)="$event.stopPropagation(); removeStageClicked(stage)">
                                            <mat-icon>remove_circle</mat-icon>
                                        </button>
}
                                    </mat-expansion-panel-header>
                                    <cb-table [loaded]="true" [stringColumns]="activityColumns">
                                        <tbody cbTableBody
                                               cdkDropList
                                               [id]="DropList.Activities + stage.buildStageId"
                                               [cdkDropListData]="stage.activities"
                                               [cdkDropListConnectedTo]="stageActivitiesConnected"
                                               (cdkDropListDropped)="dropActivity(stage, $event)"
                                               [cdkDropListDisabled]="!isEditing$.value">
                                        @for (activity of stage.activities; track activity) {
<tr
                                            cbTableRow
                                            [class.dragable]="isEditing$.value"
                                            cdkDrag
                                            cdkDragPreviewClass="cb-table-drag-preview"
                                            [cdkDragDisabled]="!isEditing$.value">
                                            <td>
                                                @if (activity.relationships?.length) {
<mat-icon>attachment</mat-icon>
}
                                            </td>
                                            <cb-td-text [value]="activity.activity.code"></cb-td-text>
                                            <cb-td-text [value]="activity.activity.name"></cb-td-text>
                                            <td>{{ activity.activityDurationDays || '0' }} days</td>
                                            <td cbTableStickyCol="end" cbTableShrinkCol>
                                                @if (!isEditing$.value) {
<button
                                                        mat-icon-button
                                                        [disabled]="!canEdit()"
                                                        (click)="activityEditClicked(stage, activity)">
                                                    <mat-icon>edit</mat-icon>
                                                </button>
}
                                                @if (isEditing$.value && canRemoveActivity(activity)) {
<button
                                                        mat-icon-button
                                                        [disabled]="!canEdit()"
                                                        (click)="removeActivityClicked(stage, activity)">
                                                    <mat-icon>remove_circle</mat-icon>
                                                </button>
}
                                                @if (isEditing$.value && !canRemoveActivity(activity)) {
<button
                                                        mat-icon-button
                                                        disabled>
                                                    <mat-icon>lock</mat-icon>
                                                </button>
}
                                            </td>
                                        </tr>
}

                                        @if (!stage.activities?.length) {
<tr cbTableRow>
                                            <td colspan="5">
                                                <mat-icon class="mat-accent">info</mat-icon>&nbsp;
                                                <span class="mat-body-2">
                                                    {{
                                                        isEditing$.value
                                                            ? 'To get started, please drag one or more Build Activities from the right into this Stage.'
                                                            : 'There are no activities in this stage.'
                                                    }}
                                                </span>
                                            </td>
                                        </tr>
}
                                        </tbody>
                                    </cb-table>
                                </mat-expansion-panel>
}

                                @if (!template.stages?.length) {
<mat-card>
                                    <mat-card-content>
                                        <span>There are no items to display</span>
                                    </mat-card-content>
                                </mat-card>
}
                            </div>
                        </div>

                        @if (isEditing$.value) {
<mat-card class="cb-no-padding flex-34">
                            <mat-card-content>
                                <mat-tab-group class="flex" mat-stretch-tabs="false">
                                    <mat-tab label="Stages">
                                        <ng-template [matTabContent]>
                                            <div class="scrollable-container cb-padding">
                                                <small>
                                                    <strong>Drag Stages to the Template</strong>
                                                </small>
                                                <cb-table [loaded]="true"
                                                          class="cb-margin-top cb-margin-bottom-2x">
                                                    <thead cbTableHead>
                                                    <th>Code</th>
                                                    <th>Stage</th>
                                                    </thead>
                                                    <tbody cbTableBody cdkDropList
                                                           [id]="DropList.AvailableStages"
                                                           [cdkDropListEnterPredicate]="denyDropIntoSource"
                                                           [cdkDropListData]="availableStages"
                                                           [cdkDropListConnectedTo]="['template-stages-drop-list']">
                                                    @for (stage of availableStages; track stage) {
<tr
                                                        cbTableRow cdkDrag
                                                        cdkDragPreviewClass="cb-table-drag-preview">
                                                        <cb-td-text [value]="stage.code"></cb-td-text>
                                                        <cb-td-text [value]="stage.label"></cb-td-text>
                                                    </tr>
}
                                                    </tbody>
                                                </cb-table>
                                            </div>
                                        </ng-template>
                                    </mat-tab>
                                    <mat-tab label="Activities">
                                        <ng-template [matTabContent]>
                                            <div class="scrollable-container cb-padding">
                                                <div>
                                                    <small>
                                                        <strong>Drag Activities to Stages in the Template</strong>
                                                    </small>
                                                </div>
                                                <form class="cb-margin-top">
                                                    <cb-input label="Filter Activities"
                                                              name="activityFilter"
                                                              [ngModelOptions]="{standalone: true}"
                                                              [(ngModel)]="activityFilter"
                                                              (change)="setAvailableActivities()"></cb-input>
                                                </form>
                                                <cb-table [loaded]="true"
                                                          class="cb-margin-bottom-2x">
                                                    <thead cbTableHead>
                                                    <th>Code</th>
                                                    <th>Activity</th>
                                                    </thead>
                                                    <tbody cbTableBody cdkDropList
                                                           [id]="DropList.AvailableActivities"
                                                           [cdkDropListEnterPredicate]="denyDropIntoSource"
                                                           [cdkDropListData]="availableActivities"
                                                           [cdkDropListConnectedTo]="activityTargets">
                                                    @for (activity of availableActivities; track activity) {
<tr
                                                        cbTableRow cdkDrag
                                                        cdkDragPreviewClass="cb-table-drag-preview"
                                                        [cdkDragDisabled]="!isEditing$.value">
                                                        <cb-td-text [value]="activity.code"></cb-td-text>
                                                        <cb-td-text [value]="activity.name"></cb-td-text>
                                                    </tr>
}
                                                    </tbody>
                                                </cb-table>
                                            </div>
                                        </ng-template>
                                    </mat-tab>
                                </mat-tab-group>
                            </mat-card-content>
                        </mat-card>
}
                    </div>
}
                </ng-template>
            </mat-tab>

            <mat-tab label="History" [disabled]="isEditing$.value">
                <ng-template [matTabContent]>
                    <cb-history-list [entityId]="templateId"
                                     [entity]="HISTORY_SEARCH_ENTITY.BuildProgrammeTemplate">
                    </cb-history-list>
                </ng-template>
            </mat-tab>
        </mat-tab-group>
    </div>

    @if (template) {
<cb-build-programme-template-side-panel
                                            class="cb-margin"
                                            [template]="template"
                                            [canEdit]="canEdit()"
                                            [isEditing$]="isEditing$"
                                            [refresh$]="refresh$"
                                            (saveClick)="saveClicked()">
    </cb-build-programme-template-side-panel>
}
</div>
